var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('v-chip',{class:_vm.style.class,attrs:{"small":"","color":_vm.style.color,"dark":_vm.style.dark}},[_vm._v("\n  "+_vm._s(_vm.localized ? _vm.$t(_vm.text) : _vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }